import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NewServicesOrderComponent } from './new-service-work-order.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { DxToolbarModule, DxFilterBuilderModule, DxAccordionModule,DxFileUploaderModule,DxDropDownButtonModule, DxButtonGroupModule, DxAutocompleteModule, DxContextMenuModule, DxDropDownBoxModule, DxGanttModule, DxPopupModule, DxRadioGroupModule, DxSchedulerModule, DxScrollViewModule, DxSelectBoxModule, DxSliderModule, DxTabPanelModule, DxTextBoxModule, DxTreeViewModule, DxDataGridModule, DxTagBoxModule, DxDateBoxModule, DxCheckBoxModule, DxButtonModule, DxPopoverModule, DxTextAreaModule } from 'devextreme-angular';

import { NewContactModule } from 'src/app/shared/new-contact/new-contact.module';
import { NewEmployeeModule } from 'src/app/shared/new-employee/new-employee.module';
import { NewServiceSiteModule } from 'src/app/pages/sales-management/employee-activities/forms/new-service-site/new-service-site.module';
import { SharedDatagridModule } from 'src/app/shared/shared-datagrid/shared-datagrid.module';
import { CreateUpdateSalesProjectModule } from 'src/app/pages/sales-management/sales-project/create-update-sales-project/create-update-sales-project.module';


@NgModule({
  declarations: [
    NewServicesOrderComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxTextBoxModule,
    DxSelectBoxModule,
    DxButtonModule,
    DxAutocompleteModule,
    GooglePlaceModule,
    DxCheckBoxModule,
    DxAccordionModule,
    DxFilterBuilderModule,
    DxFileUploaderModule,
    DxDropDownButtonModule,
    DxButtonGroupModule,
    DxAutocompleteModule,
    DxContextMenuModule,
    DxDropDownBoxModule,
    DxGanttModule,
    DxPopupModule,
    DxRadioGroupModule,
    DxSchedulerModule,
    DxScrollViewModule,
    DxSelectBoxModule,
    DxSliderModule,
    DxTabPanelModule,
    DxTextBoxModule,
    DxTreeViewModule,
    DxDataGridModule,
    DxTagBoxModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    DxButtonModule,
    NewContactModule,
    NewEmployeeModule,
    NewServiceSiteModule,
    DxToolbarModule,
    DxPopoverModule,
    DxTextAreaModule,
    CreateUpdateSalesProjectModule,
    // SharedDatagridModule
  ],
  exports: [NewServicesOrderComponent]
})
export class NewServiceWorkOrderModule { }
